import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Crowdsourcing elegance",
  "description": "",
  "published": "2011-10-10T00:00:00.000Z",
  "redirect_from": ["/blog/crowdsourcing-elegance/swizec/2608"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/6229977151_4f39755c38_m1.jpg",
        "alt": "soba fest 095",
        "title": "soba fest 095"
      }}></img></p>
    <p>{`On Friday I said that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/functional-isnt-always-better/swizec/2591",
        "title": "Functional isn’t always better"
      }}>{`Functional isn't always better`}</a>{`, but really it was a post about my failings as a functional programmer in finding an elegant solution to the problem of transforming a list of values into a list of pairs.`}</p>
    <p>{`Originally I described the problem like so:`}</p>
    <blockquote>
      <p parentName="blockquote">{`The problem is one of turning a list of values, say, `}<em parentName="p">{`[`}{`A, B, C, D]`}</em>{` into a list of pairs with itself, like so `}<em parentName="p">{`[`}{`[`}{`A,B], `}{`[`}{`A,C], `}{`[`}{`A,D], `}{`[`}{`B, C], `}{`[`}{`B,D], `}{`[`}{`C,D]].`}</em></p>
      <p parentName="blockquote">{`Should be simple enough right? You just make another list shifted by one to the left, make a zip, then repeat until the second list is empty. This solution turns out to be horrible, looks ugly and I’m not even going to show it. So here’s my second functional solution … it’s a lot cleaner.`}</p>
    </blockquote>
    <p>{`Turns out the internet is `}<em parentName="p">{`super awesome`}</em>{` and was more than willing to put me in my place. You guys posted a cumulative of 49 comments (on hackernews and this blog) and `}<a parentName="p" {...{
        "href": "http://exampler.com/"
      }}>{`Brian Marick`}</a>{` even posted a tutorial on approaching functional programming on this example, entitled `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.exampler.com/blog/2011/10/07/top-down-design-in-functional-classic-programming-2/"
        }}>{`Top-down design in "functional classic" programming`}</a>{`.`}</em></p>
    <p>{`Solutions were posted in `}<a parentName="p" {...{
        "href": "http://clojure.org",
        "title": "Clojure"
      }}>{`Clojure`}</a>{`, `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`, `}<a parentName="p" {...{
        "href": "http://www.python.org/",
        "title": "Python (programming language)"
      }}>{`Python`}</a>{`, J, Scala, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript",
        "title": "JavaScript"
      }}>{`Javascript`}</a>{`, `}<a parentName="p" {...{
        "href": "http://www.erlang.org",
        "title": "Erlang (programming language)"
      }}>{`Erlang`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Smalltalk",
        "title": "Smalltalk"
      }}>{`SmallTalk`}</a>{`, C#, `}<a parentName="p" {...{
        "href": "http://caml.inria.fr/index.en.html",
        "title": "Objective Caml"
      }}>{`Ocaml`}</a>{`, F#, ... and some language I didn't recognize nor did the poster specify what it was.`}</p>
    <h2 {...{
      "id": "clojure"
    }}>{`Clojure`}</h2>
    <p>{`They ranged from painfully obvious (`}<a parentName="p" {...{
        "href": "http://twitter.com/sbelak"
      }}>{`@sbelak`}</a>{`)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-clojure"
      }}>{`(combinations '[a b c d] 2)
`}</code></pre>
    <p>{`A saner (only core) solution in Clojure supposedly looks like this`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-clojure"
      }}>{`(defn tails [xs]
  (take-while not-empty (iterate rest xs)))

(defn pairs [xs]
  (mapcat (partial map vector) (map repeat xs) (rest (tails xs))))
`}</code></pre>
    <h2 {...{
      "id": "j"
    }}>{`J`}</h2>
    <p>{`To what the fuck am I looking at (I think this is J)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-J"
      }}>{`a = 'abcd'

comb=: 4 : 0
 k=. i.>:d=.y-x
 z=. (d$ ,&.>/\\. >:&.> z end.
 ; z
)

(2 comb #a) { a
`}</code></pre>
    <p>{`Most people seem to have given it a shot in either Clojure or Haskell, meaning that I need to look up both of those languages a whole lot more.`}</p>
    <h2 {...{
      "id": "haskell"
    }}>{`Haskell`}</h2>
    <p>{`This is my favourite Haskell solution, by `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/purzelrakete"
      }}>{`@purzelrakete`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-haskell"
      }}>{`[[x, y] | x <- set, y <- set, x < y]/pre>
`}</code></pre>
    <h2 {...{
      "id": "javascript"
    }}>{`Javascript`}</h2>
    <p>{`A really cool Javascript solution by Shaun Gilchrist.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function pairs(set) {
  return _.isEmpty(set)
    ? []
    : _.map(_.rest(set), function (y) {
        return [_.first(set), y];
      }).concat(pairs(_.rest(set)));
}
`}</code></pre>
    <h2 {...{
      "id": "c"
    }}>{`C`}</h2>
    <p>{`For some reason I didn't think C# would even make it to such a debate, but `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/user?id=Strilanc"
      }}>{`Strilanc`}</a>{` makes it quite elegant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-C"
      }}>{`list.SelectMany((e, i) => list.Skip(i+1).Select(f => Tuple.Create(e, f)))
`}</code></pre>
    <h2 {...{
      "id": "python"
    }}>{`Python`}</h2>
    <p>{`Here's a nice succint solution in Python`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`[(x[i],x[j]) for i in range(len(x)) for j in range(i+1, len(x))]
`}</code></pre>
    <h2 {...{
      "id": "ocaml"
    }}>{`Ocaml`}</h2>
    <p>{`And Ocaml by the same guy (`}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/user?id=fab13n"
      }}>{`fab13n`}</a>{`)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ocaml"
      }}>{`let rec pairs = function
    | a :: b -> List.map (fun x -> (a, x)) b @ (pairs b)
    | [] -> []
`}</code></pre>
    <h2 {...{
      "id": "f"
    }}>{`F`}</h2>
    <p>{`According to `}<a parentName="p" {...{
        "href": "http://twitter.com/demisbellot"
      }}>{`@demisbellot`}</a>{` it would look like this in F#`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-F"
      }}>{`let rec pairs = function
| h :: t -> List.append [ for i in t -> [h; i] ] (pairs t)
| _ -> []

["A"; "B"; "C"; "D"] |> pairs
`}</code></pre>
    <h2 {...{
      "id": "scala"
    }}>{`Scala`}</h2>
    <p>{`Scala by XxXX`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-scala"
      }}>{` def pair(l : List[String]): List[Tuple2[String, String]] = l.size match {
 case 1 => Nil
 case _ => l.tail.flatMap { e => List((l.head, e)) } ++ pair(l.tail)
}
`}</code></pre>
    <h2 {...{
      "id": "erlang"
    }}>{`Erlang`}</h2>
    <p>{`By `}<a parentName="p" {...{
        "href": "http://joelpm.com/"
      }}>{`JoelPM`}</a>{` ... although I'm not sure this is elegant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-erlang"
      }}>{`-module(combos).

-export([ combo/1 ]).

combo(List) ->
  combo(List,[]).

combo([],Acc) ->
  lists:reverse(Acc);
combo([H|T], Acc) ->
  combo(T,permute(H,T,Acc)).

permute(X,[],Acc) ->
  Acc;
permute(X,[H|T],Acc) ->
  permute(X,T,[{X,H}|Acc]).
Output:
1> combos:combo([a,b,c,d]).[{a,d},{a,c},{a,b},{b,d},{b,c},{c,d}]2>
`}</code></pre>
    <h2 {...{
      "id": "more-javascript"
    }}>{`More javascript`}</h2>
    <p>{`@refaktor gave it the most attempts ... I think he had a boring weekend, or just got nerd sniped. Here's his his final solution in javascript ... would have expected rebol from him though.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var f = function (a) {
  return a.length == 0
    ? []
    : a
        .slice(1)
        .map(function (x) {
          return [a[0], x];
        })
        .concat(f(a.slice(1)));
};
`}</code></pre>
    <h2 {...{
      "id": "smalltalk"
    }}>{`Smalltalk`}</h2>
    <p>{`By Larry ... he didn't leave a link.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-smalltalk"
      }}>{`in := #(a b c d) asOrderedCollection.out := OrderedCollection new.in size timesRepeat: [    key := in removeFirst.  in do: [ :value |  out add:( Array with: key with: value). ].].
`}</code></pre>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`There were other good solutions, but I think these are the most interesting to look at. This whole experience proves that sometimes when you ask for help on the internets Good Things (tm) happen.`}</p>
    <p>{`It also proves that geeks `}<em parentName="p">{`love`}</em>{` outdoing each other.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.r-bloggers.com/hipster-programming-languages/"
        }}>{`Hipster programming languages`}</a>{` (r-bloggers.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mathias-biilmann.net/posts/2011/10/is-haskell-the-cure"
        }}>{`Is Haskell the Cure?`}</a>{` (mathias-biilmann.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dave.fayr.am/posts/2011-08-19-lets-go-shopping.html"
        }}>{`Functional Programming Is Hard, That's Why It's Good`}</a>{` (dave.fayr.am)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://drknucklehead.wordpress.com/2011/10/02/what-is-clojure-who-should-use-it/"
        }}>{`What is Clojure? Who Should Use It?`}</a>{` (drknucklehead.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6bdf0ca8-ad82-4ee8-a403-c51e98c02053",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      